"use strict";

import {
    GET_AVAILABLE_PROJECTS,
    GET_PROJECTS_FOR_SINGLE_USER,
} from "../../ApiEndpoints";
import apiClient from "../../utils/apiClient";

export const getProjectsForSingleUser = (payload, config) => (
    apiClient.post(GET_PROJECTS_FOR_SINGLE_USER, payload, config)
);

export const getAvailableProjects = (payload, config) => (
    apiClient.post(GET_AVAILABLE_PROJECTS, payload, config)
);

export const getProjectById = (projectId) => (
    apiClient.get(`/api/projects/${projectId}`, {})
);
